import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api } from "../lib/apiClient";

export const SponsorRow = ({ slug }) => {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    if (!slug) return;
    api
      .get(`/sponsors/${slug}`)
      .then((r) => {
        const list = r.data || [];
        setSponsors(list);
        if (list.length) {
          api.post("/sponsors/impressions", { ids: list.map((s) => s.id) }).catch(() => {});
        }
      })
      .catch(() => {});
  }, [slug]);

  if (sponsors.length === 0) return null;

  const handleClick = (s) => {
    api.post(`/sponsors/${s.id}/click`).catch(() => {});
    window.open(s.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="px-6 md:px-10" data-testid="sponsor-row">
      <div className="flex items-center gap-2 mb-4">
        <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400 border border-white/15 rounded-sm px-2 py-0.5">
          Sponsored
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {sponsors.map((s) => (
          <button
            key={s.id}
            data-testid={`sponsor-card-${s.id}`}
            onClick={() => handleClick(s)}
            className="group flex items-stretch text-left bg-[#0A0A0F] border border-white/10 hover:border-[#FF2A2A]/60 rounded-md overflow-hidden transition-colors"
          >
            {s.image_url ? (
              <img
                src={s.image_url}
                alt={s.title}
                draggable={false}
                className="w-28 shrink-0 object-cover self-stretch"
              />
            ) : null}
            <div className="p-4 flex flex-col">
              <h4 className="font-semibold text-white text-sm leading-tight">{s.title}</h4>
              {s.description ? (
                <p className="text-xs text-zinc-400 mt-1 line-clamp-2">{s.description}</p>
              ) : null}
              <span className="mt-auto pt-3 inline-flex items-center gap-1 text-xs font-semibold text-[#FF2A2A] group-hover:gap-2 transition-all">
                {s.cta_text} <ExternalLink className="w-3.5 h-3.5" />
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
